
import { Button } from '@/components/ui/button';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import type { Database } from '@/integrations/supabase/types';
import { formatDate, formatTime } from '@/utils/reportFormatters';
import type { UseMutationResult } from '@tanstack/react-query';
import { useState } from 'react';
import { ApproveClassDialog } from './ApproveClassDialog';

interface SpecialClassTableProps {
  jobs: Database['public']['Views']['job_student_view']['Row'][];
  approveSpecialClassMutation: UseMutationResult<any, Error, { jobId: number, status: "approved" | "rejected", note: string }, unknown>;
}

export function SpecialClassTable({ jobs, approveSpecialClassMutation }: SpecialClassTableProps) {
  const [dialogOpenFor, setDialogOpenFor] = useState<number | null>(null);

  const handleApprove = async (status: "approved" | "rejected", note: string) => {
    await approveSpecialClassMutation.mutateAsync({ jobId: dialogOpenFor!, status, note });
    setDialogOpenFor(null);
  };


  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>วันที่เวลาที่สอน</TableHead>
          <TableHead>ครูผู้สอน</TableHead>
          <TableHead>นักเรียน</TableHead>
          <TableHead>ประเภทการสอน</TableHead>
          <TableHead>สาขา</TableHead>
          <TableHead>ระดับชั้น</TableHead>
          <TableHead>สถานะการอนุมัติ</TableHead>
          <TableHead>อนุมัติ</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {jobs.map((job) => (
          <TableRow key={job.job_id}>
            <TableCell> {formatDate(job.start_at)} <br></br> เวลา {formatTime(job.start_at)} - {formatTime(job.end_at)} น.</TableCell>
            <TableCell>
              {job.teacher_code} {job.teacher_name}
            </TableCell>
            <TableCell>
              {job.student_codes} <br></br>{job.student_names}
            </TableCell>

            <TableCell>
              {job.class_type}
            </TableCell>
            <TableCell>
              {job.branch}
            </TableCell>
            <TableCell>
              {job.education_level}
            </TableCell>
            <TableCell>
              <span className={`text-sm ${job.approve_status === "pending" ? "text-yellow-500" : job.approve_status === "approved" ? "text-green-500" : "text-red-500"}`}>{job.approve_status === "pending" ? "รอตรวจสอบ" : job.approve_status === "approved" ? "อนุมัติ" : "ไม่อนุมัติ"}</span>
              <br></br>
              <span className="text-xs text-muted-foreground">{job.note}</span>
            </TableCell>
            <TableCell>
              <div className="flex gap-x-2">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => setDialogOpenFor(job.job_id)}
                  disabled={approveSpecialClassMutation.isPending}
                >
                  ตรวจสอบ/Approve
                </Button>
                <ApproveClassDialog
                  open={dialogOpenFor === job.job_id}
                  value={{ status: job.approve_status === "approved" ? "approved" : "rejected", note: job.note }}
                  onOpenChange={(open) => setDialogOpenFor(open ? job.job_id : null)}
                  onSubmit={async (status, note) => await handleApprove(status, note)}
                  loading={approveSpecialClassMutation.isPending}
                />
              </div>
            </TableCell>


          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
